export default {
	powTourPrvsMngManagements: [],
	excelDownLoadList: [], //엑셀다운로드시 해더저장

	/** selectbox */
	occuPlCdList: [], // 발생공정 코드목록
	allPowPrvsCdList: [], //라인 코드 총목록
	powPrvsCdList: [], // 라인 코드목록
	insnWayCdList: [], // 방식 코드목록
	insnCyclCdList: [], // 주기 코드목록
	useYnCdList: [], // 사용여부 코드목록

	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	selectedRow: SELECTED_ROW(),
	oldSelectedRow: SELECTED_ROW(),

	isOldRow: ''
};

function SEARCH_PARAMS() {
	return {
		powLnCd: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SELECTED_ROW() {
	return {
		rowType: '',
		powLnCd: '',
		powPrvsCd: '',
		prvsSn: '',
		insnWayCd: '',
		insnCyclCd: '',
		vbgStrtDd: '',
		vbgStrtDdView: '',
		insnPrvsSbc: '',
		chgrId: '',
		chgrDt: '',
		rgnDt: '',
		rgnId: '',
		tableState: '',
		useYn: '',
		powLnNm: '',
		powPrvsNm: '',
		insnWayNm: '',
		insnCyclNm: '',
		useYnNm: ''
	};
}

export { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW };
